import * as types from '../mutation-types'
import s from '../state'
import api from '@/api'
import axios from 'axios'
import {Message} from 'element-ui'
import router from '../../router'
import c from '@/common/js'

const state = {
  goods: [], 
  goodsTotal:0,
  noResult:false
}

const getters = {
    goods: state => state.goods,
    goodsTotal: state => state.goodsTotal,
    noResult:state =>state.noResult
}
const actions = {
  // 加载列表
  async loadGoodsList({commit, state}, params) {
    
    api.post('api/services/app/FrontendProduct/SearchKeyWords', params).then(res => {
        if (res.data.success === true) {
          commit(types.STORE_GOODS_TOTAL, res.data.result.totalCount)
          commit(types.LOAD_GOODS_LIST, res.data.result.items)
        }
      })
  },

}
const mutations = {
  [types.LOAD_GOODS_LIST](state, goods) {
      state.goods = goods
  },
  [types.STORE_GOODS_TOTAL](state, goodsTotal) {
   
    state.goodsTotal = goodsTotal
    if(goodsTotal){
      state.noResult = false
    }else{
      state.noResult = true
    }
  },
  
}


export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/goods.js